import React from 'react';
import { CHANNELS_CATALOG } from '../../../../utils/channelsConfig';
import { clientMenu } from './moduleCatalog';

const on = (v) => v === true || v === 'true';

/**
 * Vista previa en vivo de lo que verá el cliente: el menú de su dashboard,
 * los canales del agente y cómo se mide. Se actualiza con cada interruptor.
 */
export default function ClientMenuPreview({ modules, channels, profileName, agentTypeName }) {
  const menu = clientMenu(modules);
  const intel = (modules || []).find((m) => m.module === 'inteligencia');
  const enabledChannels = CHANNELS_CATALOG.filter((c) => on(channels?.[0]?.[c.key]));

  return (
    <aside aria-label="Vista previa del cliente" className="space-y-4">
      <div>
        <p className="text-sm font-semibold" style={{ color: '#E8EAF0' }}>Así verá el menú tu cliente</p>
        <p className="text-xs mt-0.5" style={{ color: '#8A90AD' }}>Cambia en vivo mientras activas módulos.</p>
      </div>

      <div className="rounded-2xl p-3" style={{ backgroundColor: '#0a0b17', border: '1px solid rgba(255,255,255,0.07)' }}>
        <div className="flex items-center gap-2 px-2 pb-3 mb-2" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
          <span className="h-5 w-5 rounded-md" style={{ backgroundColor: 'rgba(0,194,255,0.35)' }} aria-hidden />
          <span className="text-xs font-semibold" style={{ color: '#C9CCE0' }}>{agentTypeName || 'Dashboard del cliente'}</span>
        </div>
        <ul className="space-y-0.5">
          {menu.map((item, i) => (
            <li
              key={item.key}
              className="flex items-center gap-2.5 rounded-lg px-2.5 py-1.5 text-[13px]"
              style={i === 0 ? { backgroundColor: 'rgba(0,194,255,0.12)', color: '#7FDBFF' } : { color: '#A7ACC6' }}
            >
              <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: i === 0 ? '#00C2FF' : '#3A3F5C' }} aria-hidden />
              {item.label}
            </li>
          ))}
        </ul>
        {menu.length === 1 && (
          <p className="text-xs px-2.5 pt-2" style={{ color: '#5A6080' }}>Solo verá Inicio. Activa módulos para agregar secciones.</p>
        )}
      </div>

      <dl className="space-y-3 text-xs">
        <div>
          <dt style={{ color: '#5A6080' }}>Canales del agente</dt>
          <dd className="mt-1 flex flex-wrap gap-1.5">
            {enabledChannels.length ? enabledChannels.map((c) => (
              <span key={c.key} className="rounded-md px-2 py-0.5" style={{ backgroundColor: 'rgba(34,197,94,0.12)', color: '#86EFAC' }}>{c.label}</span>
            )) : <span style={{ color: '#8A90AD' }}>Ninguno todavía</span>}
          </dd>
        </div>
        <div>
          <dt style={{ color: '#5A6080' }}>Avisos de IA</dt>
          <dd className="mt-1" style={{ color: intel?.view ? '#86EFAC' : '#8A90AD' }}>{intel?.view ? 'Activos (botón ✨)' : 'Apagados'}</dd>
        </div>
        <div>
          <dt style={{ color: '#5A6080' }}>Cómo se mide</dt>
          <dd className="mt-1" style={{ color: intel?.special_actions?.can_view_qa ? '#C9CCE0' : '#8A90AD' }}>
            {intel?.view && intel?.special_actions?.can_view_qa ? (profileName || 'Perfil del tipo de agente') : 'Sin calidad de atención'}
          </dd>
        </div>
      </dl>
    </aside>
  );
}
